export default "__VITE_ASSET__C3ie0WV5__"